import { useState, useEffect } from 'react';

interface DeviceType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const useDeviceType = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
  });

  useEffect(() => {
    const handleResize = (): void => {
      const width = window.innerWidth;
      
      setDeviceType({
        isMobile: width < 768,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024,
      });
    };

    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures effect is only run on mount and unmount

  return deviceType;
};

export default useDeviceType;

// Usage example:
/*
import useDeviceType from '@/hooks/useDeviceType';

const MyComponent = () => {
  const { isMobile, isTablet, isDesktop } = useDeviceType();

  return (
    <div>
      {isMobile && <div>Mobile Content</div>}
      {isTablet && <div>Tablet Content</div>}
      {isDesktop && <div>Desktop Content</div>}
    </div>
  );
};
*/